import { useSeo } from "@/lib/site";
import { Marquee } from "@/components/site/Marquee";
import { HomeHero } from "@/components/home/HomeHero";
import { SearchChanging, SeoBento } from "@/components/home/HomeSeo";
import { AiSearch, AiReady } from "@/components/home/HomeAi";
import { Expertise, Results, AuditCallout } from "@/components/home/HomeProof";
import { ReportingDashboard } from "@/components/home/ReportingDashboard";
import { Awards } from "@/components/home/Awards";
import { Podcast } from "@/components/home/Podcast";
import { Insights, Studio, FinalCta } from "@/components/home/HomeMore";

export default function Home() {
  useSeo(
    "SEO Agency UK | SEO & AI Search Visibility | Perfect Digitals",
    "Perfect Digitals is a UK SEO and AI Search Visibility agency helping businesses improve visibility across Google, ChatGPT, Gemini, Perplexity and AI search."
  );
  return (
    <div data-testid="home-page">
      <HomeHero />
      <Marquee />
      <Awards />
      <SearchChanging />
      <SeoBento />
      <AiSearch />
      <AiReady
        intro={["AI Search Optimisation should not be treated as a replacement for SEO.", "Strong AI visibility is built on many of the same foundations that have always made businesses easier to discover and trust online."]}
        outro="That is why Perfect Digitals approaches SEO and AI Search Visibility as one connected discipline rather than two unrelated services."
      />
      <Expertise />
      <Results />
      <ReportingDashboard />
      <AuditCallout />
      <Insights />
      <Podcast />
      <Studio />
      <FinalCta />
    </div>
  );
}
